import React from "react";
import { Redirect } from "react-router-dom";
import Loading from "../../componentes/Loading/Loading";
import { GetMenusComponent } from "../../graphql/components";
import { possuiMenuPermitido } from "../../utils/menuPermissaoUtil";
import Routes from "../../utils/routes";

const comPermissaoDeMenu = (page: string, Component: any) => {
  const ComPermissao = (props: any) => (
    <GetMenusComponent>
      {({ data, loading }) => {
        if (loading) {
          return <Loading />;
        }
        if (!possuiMenuPermitido(data && data.getMenus, page)) {
          return <Redirect to={{ pathname: Routes.notAllowed.route }} />;
        }
        return <Component {...props} />;
      }}
    </GetMenusComponent>
  );
  ComPermissao.paginaDeMenu = page;
  return ComPermissao;
};

export default comPermissaoDeMenu;
